module.exports = __webpack_public_path__ + "static/media/white-logo.592c6aad.svg";